import React from "react";
import styled from "styled-components";
import { Typography, useTheme, useMediaQuery } from "@mui/material";

const Layout = styled.div`
  background: linear-gradient(45deg, #3fd6fb, #343ded);
  padding: 8px 10px;
  text-align: center;
  align-items: center;
  justify-content: center;
  color: #fff;
`;

const Banner: React.FC = () => {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Layout>
      <Typography
        fontSize={md ? "16px" : "12px"}
        fontWeight={500}
        fontFamily="Montserrat"
      >
        Always verify the website address is https://connect.six.zone
      </Typography>
    </Layout>
  );
};

export default Banner;
